export default "__VITE_ASSET__CXXb$7KK__"